import React, { useEffect, useState } from "react";
import "./static.css";
import { Helmet } from "react-helmet";

const DummyPage: React.FC = () => {
  useEffect(() => {
    document.title = "Contact";
  }, []);
  return (
    <div className="dummy-container-static">
      <Helmet key="Contact">
        <title>Contact</title>
        <meta name="description" content="Reach out to us via email." />
      </Helmet>
      <h1 className="dummy-heading1-static">Contact</h1>
      <p className="dummy-paragraph-static">
        The Trialhouse/Ivy Bloat team is happy to answer your questions. Please
        reach out through the following channels.
      </p>
      <h2 className="dummy-heading2-static">
        General Questions & Press Inquiries
      </h2>
      <p className="dummy-paragraph-static">
        Email Alex Shieh at{" "}
        <a
          className="dummy-link-static"
          href="mailto:alex@alexshieh.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          alex@alexshieh.com
        </a>{" "}
        and he'll respond as soon as he can.
      </p>
      <h2 className="dummy-heading2-static">Confidential Tips</h2>
      <p className="dummy-paragraph-static">
        Do you have information that you want to share? Send Alex a confidential
        tip at{" "}
        <a
          className="dummy-link-static"
          href="mailto:alexshieh@proton.me"
          target="_blank"
          rel="noopener noreferrer"
        >
          alexshieh@proton.me
        </a>
        . Do not use a school/work email address, a school/work-issued device,
        or school/work WiFi. For extra security, you can create a burner email
        account without using your real name and access it using Tor Browser.
      </p>
      <h2 className="dummy-heading2-static">See More</h2>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="/about"
          rel="noopener noreferrer"
        >
          Learn about the project
        </a>
      </p>
      <p className="dummy-paragraph-static">
        <a
          className="dummy-link-static"
          href="https://x.com/alexkshieh"
          target="_blank"
          rel="noopener noreferrer"
        >
          Check us out on X
        </a>
      </p>
    </div>
  );
};

export default DummyPage;
